<p *ngIf="personList?.length == 0">Non sono presenti persone</p>
<div class="row">
  <div class="col-12">
    <table class="table">
      <caption class="sr-only">Tabella persone</caption>
      <thead>
        <tr>
          <th>Nominativo</th>
          <th>Identificativo</th>
          <th>Tipo</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let person of personList; let i = index">
          <td *ngIf="person.name">
            {{person.name}}
          </td>
          <td *ngIf="person.firstName && person.lastName">
            {{person.firstName}} {{person.lastName}}
          </td>
          <td *ngIf="person.name && person.vatNumber">
            {{person.vatNumber}}
          </td>
          <td *ngIf="!person.vatNumber && person.taxNumber">
            {{person.taxNumber}}
          </td>
          <td>
            {{getTypeValue(person.type)}}
          </td>
          <td class="col-xs-3 cell">
            <div class="data_opzioni classificazione">
              <ul>
                <li class="opzioni" appDropdownFocus>
                  <a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                    aria-expanded="false">Opzioni<span class="glyphicon glyphicon-option-vertical"></span></a>
                  <div class="dropdown-menu dropdown-table">
                    <ul>
                      <li>
                        <span class="glyphicon ml-0 glyphicon-pencil span-icon"></span>
                        <a href="javascript:void(0)" (click)="onEditPerson(person)">Modifica</a>
                      </li>
                      <li>
                        <span class="glyphicon ml-0 glyphicon-trash span-icon"></span>
                        <a href="javascript:void(0)" (click)="onDeletePerson(person)">Elimina</a>
                      </li>
                      <li>
                        <span class="glyphicon ml-0 glyphicon glyphicon-cog span-icon"></span>
                        <a href="javascript:void(0)" [routerLink]="['dettaglio', person.id]">Dettagli persona
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
